import { DefaultObserveImage } from "@/components/image/DefaultObserveImage/DefaultObserveImage";
import { NoteElementType } from "@/types/NotesTypes";
import { observer } from "mobx-react-lite";
import styles from "./NotePatches.module.css";
// import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";
import { CancelButton } from "@/components/button/SaveEditCancel/CancelButton";
import { TematicalColorButton } from "@/components/button/TematicalColorButton/TematicalColorButton";
import { TextAreaWithScrollBar } from "@/components/textarea/TextAreaWithScrollBar/TextAreaWithScrollBar";
import { useImagePreview } from "@/hooks/useImagePreview";
import { formNotesStore } from "@/stores/NotesStore";
import clsx from "clsx";
import { useEffect } from "react";

interface ElementProps {
  idNote: number;
  el: NoteElementType;
  editMode?: boolean;
}

export const Element = observer(({ idNote, el, editMode }: ElementProps) => {
  const { file, preview, clear, change } = useImagePreview();

  useEffect(() => {
    formNotesStore.updateValueElement(idNote, el.id, "image", file || null);
  }, [file]);

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    change(e);
    e.target.value = "";
  };

  const src = editMode ? preview : el.content;
  return (
    <div className={styles.element}>
      {el.type === "image" ? (
        <div className={clsx(editMode && styles.overlayElement, editMode && styles.imageEdit)}>
          <DefaultObserveImage src_image={src || "uploads/fairs/default/default.jpg"} alt="image" />
          {editMode && (
            <section className={styles.imgDivButtons}>
              {!file ? (
                <TematicalColorButton>
                  <input type="file" onChange={onChange} hidden id={`el-change${el.id}`} />
                  <label htmlFor={`el-change${el.id}`}>Изменить</label>
                </TematicalColorButton>
              ) : (
                <TematicalColorButton onClick={() => clear()}>Вернуть изначальное фото</TematicalColorButton>
              )}
              <CancelButton onClick={() => formNotesStore.removeNoteElement(idNote, el.id)}>
                Удалить
              </CancelButton>
            </section>
          )}
        </div>
      ) : (
        <div className={clsx(editMode && styles.overlayElement, editMode && styles.titleEdit)}>
          {editMode ? (
            <TextAreaWithScrollBar
              backValue={(e) => formNotesStore.updateValueElement(idNote, el.id, "text", e)}
            ></TextAreaWithScrollBar>
          ) : (
            <span>{el.content}</span>
          )}
          {editMode && (
            <CancelButton onClick={() => formNotesStore.removeNoteElement(idNote, el.id)}>
              Удалить
            </CancelButton>
          )}
        </div>
      )}
    </div>
  );
});
